// tableFloatingMenuPlugin.js
// ProseMirror plugin for a dedicated floating menu when the cursor is inside a
// table cell or a multi-cell CellSelection is active.

import {Plugin, PluginKey} from "prosemirror-state";
import {TableFloatingMenuTooltip} from "./tableFloatingMenu/TableFloatingMenuTooltip";

export const tableFloatingMenuKey = new PluginKey("tableFloatingMenu");

/**
 * Create the table floating menu plugin.
 * Mounts a TableFloatingMenuTooltip as a plugin view so it follows the same
 * lifecycle (update / destroy) as every other ProseMirror tooltip.
 *
 * @returns {Plugin}
 */
export function createTableFloatingMenuPlugin() {
    return new Plugin({
        key: tableFloatingMenuKey,
        view(editorView) {
            return new TableFloatingMenuTooltip(editorView);
        },
    });
}
